export default __webpack_public_path__ + "static/lowrider-f3ee38b7a4687ea7b6dabb3c5b2c953f.png";